import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { MatDrawerMode, MatSidenav } from '@angular/material/sidenav';
import { NavService, NavigationElement } from '../navigation/nav.service';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { LayoutService } from '../layout/layout.service';
import { ResponsiveService } from '../responsive.service';
import { AuthService } from '../authentication/auth.service';

@Component({
  selector: 'as-mat-sidenav',
  templateUrl: './as-mat-sidenav.component.html',
  styleUrls: ['./as-mat-sidenav.component.scss'],
  standalone: false
})
export class AsMatSidenavComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() nested = true;
  // @Input() fixedTopGap = 0;
  @Input() navigationElements?: NavigationElement[];
  @Input() isMainNav = false;
  @Input() primaryColor?: string;
  @Input() secondaryColor?: string;
  @Input() logoUri?: string;
  @Input() sideNavTitle?: string;
  @Input() sidenavClass?: string;
  @Input() withBottomPadding = true;
  @Input() withMiniNav = true;

  @ViewChild(MatSidenav) sidenav?: MatSidenav;

  get fixedTopGap(): number { return this.nested ? this.layoutService.layoutHeightOffsetTop : 0; }

  role$ = new BehaviorSubject<string>('navigation');
  opened$ = new BehaviorSubject<boolean>(true);
  mode$ = new BehaviorSubject<MatDrawerMode>('side');
  destroy$ = new Subject<void>();

  isHandset$: Observable<boolean> = this.responsive.breakpoints.observe(Breakpoints.Handset).pipe(
    map((result) => result.matches),
    shareReplay(),
  );

  currentPage?: string;
  containerHeight: string = '100%';

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private readonly authService: AuthService,
    private readonly responsive: ResponsiveService,
    private readonly layoutService: LayoutService,
    private readonly navService: NavService,
    private readonly changeDetection: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    void this.authService.getCurrentUser().then((_) => {
      this.navigationElements = this.navigationElements?.filter((x) => this.navService.isAllowed(x));
    });

    this.isHandset$
      .pipe(
        tap((value) => {
          this.mode$.next(value ? 'over' : 'side');
          this.opened$.next(!value);
          this.role$.next(value ? 'dialog' : 'navigation');
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();

    // Update page name
    this.layoutService.navInfo$.pipe(takeUntil(this.destroy$)).subscribe((info) => {
      if (info) {
        this.currentPage = info.name ?? '';
      }
    });
  }

  ngAfterViewInit(): void {
    this.changeDetection.detectChanges();

    if (this.sidenav) {
      this.sidenav.openedChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
